module.exports = __webpack_public_path__ + "static/media/6540.8d72f7c3.jpg";